import type { JSX, ReactNode } from 'react'

import { clsx } from 'clsx'

import styles from '~publish/legacy/composer/composer/components/css/MediaAttachment.module.css'

export function MediaAttachmentTray({
  adjustedPadding = false,
  children,
}: {
  adjustedPadding?: boolean
  children: ReactNode
}): JSX.Element {
  return (
    <div
      className={clsx(
        styles.mediaAttachment,
        adjustedPadding && styles.adjustedPaddingHack,
      )}
    >
      {children}
    </div>
  )
}
